import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
`;

export const TipoConta = styled.div<{ label?: string }>`
  margin-top: 20px;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 10px;
  padding: 8px;
  border: 2px solid #dfe1e6;
  border-radius: 3px;
  background: #fff;

  ${({ label }) =>
    label &&
    css`
      &::before {
        content: '${label}';
        position: absolute;
        top: -10px;
        left: 8px;
        padding: 0 4px;
        font-size: 13px;
        line-height: 1;
        color: #6b7280;
        background: #fff;
        pointer-events: none;
      }
    `}

  .ButtonCheck {
    min-width: 70px;
    background-color: #8850bf;
    color: #fff;
    border-radius: 5px;
    padding: 4px 25px 5px 30px;
    cursor: pointer;
    transition: 0.3s;
    label {
      cursor: pointer;
    }
  }

  .form-check-input:focus {
    border-color: transparent !important;
    box-shadow: transparent !important;
  }
  .form-check-input:checked {
    background-color: #8850bf;
    border-color: transparent !important;
    transition: 0.3s;
  }
`;
